import { useEffect } from 'react';

interface ScrollToTopOptions {
  behavior?: 'smooth' | 'instant';
  delay?: number;
  /** Include a value here (e.g. a tab/view key) to re-run the scroll whenever it changes, instead of only on mount. */
  trigger?: unknown;
}

export const useScrollToTop = (options: ScrollToTopOptions = {}) => {
  const { behavior = 'smooth', delay = 0, trigger } = options;

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior,
      });
    };

    if (delay > 0) {
      const timer = setTimeout(scrollToTop, delay);
      return () => clearTimeout(timer);
    } else {
      scrollToTop();
    }
    // No `trigger` by default (undefined on every call) means this runs only on initial render, as before.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);
};